<button class="button" (click)="showParentFilter()">
    <i class="fas fa-search"></i>
</button>

@if (parentFilter?.values?.length) {
    <div class="defaultStatusFilterWrapper">
        @for (filterValue of parentFilter.values; track filterValue) {
            <app-boolean-cell-renderer [displayValue]="filterValue" [isFloatingFilterIcon]="true" />
        }
    </div>
}
